import React, { useEffect, useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import SideDrawer from './SideDrawer';
import img from "../../resources/images/logo new.jpg"
import { Link } from 'react-router-dom';
import { useData } from '../../context/DataContext';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    position: `absolute`,
    top: `50%`,
    right: theme.spacing(5),
    transform: `translateY(-50%)`
  },
  white: {
    backgroundColor: `#fff`
  },
  title: {
    flexGrow: 1,
    padding: `5px 0`,
    textAlign: `center`
  },
}));

const Header = ({setHeight}) => {
  const classes = useStyles();
  const { website_details }= useData();
  const app = useRef()
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const [imgLoaded, setImgLoaded] = useState(false);
  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);
  useEffect(()=>{
    setHeight(app.current.offsetHeight)
  },[setHeight,imgLoaded])
  return (
    <div className={classes.root}>
      <AppBar position="fixed" ref={app} className={classes.white+" shadow"} color="default">
        <Toolbar variant="regular">
          <div className={classes.title}>
            <Link to="/"><img onLoad={()=> setImgLoaded(true)} src={website_details?.logo?.[0]?.src} alt={website_details.website_name} style={{width: 200}} /></Link>
          </div>
          <IconButton onClick={handleNavCollapse} edge="end" className={classes.menuButton} color="inherit" aria-label="menu">
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <SideDrawer open={isNavCollapsed} onClose={handleNavCollapse}/>
    </div>
  );
};

export default Header;